import { LanguageContent } from '@app/shared/models/localizable/language-content';
import { Entity, EntityConfiguration, EntityTypeOf, Schema } from '@technocom/data/core';

export interface LocalizableDTO<T = any> {
  id: number;
  contents: Array<any extends T ? T : any>;
}

export class Localizable<
  T extends LocalizableDTO = LocalizableDTO,
  L extends LanguageContent = LanguageContent,
> extends Entity<T & LocalizableDTO<L>> {
  static readonly schema: Schema = Entity.extend<LocalizableDTO>({
    fields: {
      id: { type: Number },
      contents: { type: LanguageContent, multiple: true },
    },
  });
  static readonly options: EntityConfiguration = Entity.extendOptions({
    title: 'Языковое содержимое информационного материала',
  });

  /** Содержимое на выбранном языке, либо на русском */
  getLocalizedContent(lang: string = 'RU'): L {
    // special - ключ, указывающий что запись получена путём парсинга сущности через локализацию
    return (
      this.get('contents')?.find(i => i.get('language') === lang) ??
      this.get('contents')?.find(i => i.get('language') === 'special')
    );
  }

  /** Класс языкового содержимого */
  static get contentType(): EntityTypeOf<LanguageContent> {
    return this.schema.get('contents').type as EntityTypeOf<LanguageContent>;
  }

  /** Поля для локализации на основе класса языкового содержимого */
  static localizableFields() {
    return this.contentType.schema.filter(field => !this.contentType.get('ignoreParseFields').includes(field.name));
  }
}
